import recorded from './Recorded';
export default {
   async tests(type, callback){
        let tests;
        let testTypes = await recorded.get('/sampleCertTypes', {
            with: 'requirements'
        });
        for(let i in testTypes.data){
            if(type === testTypes.data[i].name){
                let requirements = testTypes.data[i].requirements;
                tests = [];
                for(let j in requirements){
                    if(requirements[j].required){
                        tests.push(requirements[j].test_name.name)
                    }
                }
                break;
            }
        }
        if(tests.length > 0){
            callback(tests);
        }else{
            callback(["P"]);
        }
    },

}
